export default "__VITE_ASSET__Dzv$Yi9H__"